module.exports = __webpack_public_path__ + "static/media/ingredients-eagle-eye.b11204c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2017-11-4/ingredients-eagle-eye.jpg
// module id = 801
// module chunks = 0